import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  > ul {
    width: 100%;
    list-style-type: none;
  }
`
